import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NotificacionService {
  song = 'assets/notification.mp3';

  constructor() { }

  showNotification(numero: number, letra: string) {
    if (Notification.permission !== 'granted') {
      Notification.requestPermission();
    } else {
      const options: NotificationOptions = {
        body: `Turno: ${letra} - ${numero}`,
        dir: 'ltr',
        image: 'image.jpg',
      };
      const notification = new Notification('Llamado al:', options);
      new Audio(this.song).play();
      notification.onclick = () => {
        notification.close();
        window.parent.focus();
        //window.open('https://www.google.com');
      };
    }
  }

}
